export const ravanaPathwayProfiles = {
  DEU: {
    student_visa: {
      headline: 'Bachelor & Master Degree in Germany',
      durations: [
        'Bachelor: 3-4 years (6-8 semesters)',
        'Master: 2 years (4 semesters)'
      ],
      popularFields: [
        'Engineering (Mechanical, Electrical, Civil)',
        'Information Technology (Computer Science, Data Science, AI)',
        'Business & Management (MBA, International Business)',
        'Medicine, Biology, Chemistry',
        'Arts & Social Sciences'
      ],
      costBreakdown: [
        {
          item: 'Semester contribution fee',
          amount: '€250-€500 (LKR 85,000-170,000)',
          note: 'Public universities; includes admin, transport, student services'
        },
        {
          item: 'Blocked account (living + insurance)',
          amount: '€13,080/year (LKR 4,470,000/year)',
          note: 'Covers initial 12 months of living expenses and insurance'
        },
        {
          item: 'Visa & residence permit',
          amount: '€100-€150 (LKR 34,000-51,000)',
          note: 'One-time embassy and residence fees'
        },
        {
          item: 'Flight to Germany',
          amount: '€600-€900 (LKR 205,000-308,000)',
          note: 'One-way ticket from Sri Lanka'
        },
        {
          item: 'Consulting fee',
          amount: 'LKR 1,190,000 (PRO Package)',
          note: 'PRO: 476,000 upfront + 357,000 after offer + 357,000 final | Plus: LKR 850,000 | DIY: LKR 400,000'
        }
      ],
      languageRequirements: [
        'English-taught programs: IELTS 6.0-6.5',
        'German-taught programs: German B1/B2 (Bachelor) or B2/C1 (Master)'
      ],
      eligibility: [
        'Bachelor applicants need A/L 3 passes',
        'Master applicants need recognized 4-year bachelor degree with minimum 2.85 GPA'
      ],
      highlights: [
        'World-class education with minimal or no tuition fees',
        '18-month job seeker visa after graduation',
        'Pathway to work opportunities across Europe',
        'Chance to master both German and English while studying'
      ],
      paymentPlan: [
        'Initial payment: LKR 595,000',
        'Balance after offer letter: LKR 595,000'
      ],
      serviceFeeLKR: 1190000,
      serviceCurrency: 'LKR'
    },
    chancenkarte: {
      headline: 'Germany Chancenkarte (Opportunity Card)',
      durations: ['Initial visa valid 6 months for job search'],
      popularFields: [
        'Engineering and skilled trades',
        'Information Technology',
        'Healthcare (nursing, medical technicians)',
        'Business & Management (finance, HR, marketing)'
      ],
      costBreakdown: [
        {
          item: 'Visa fee',
          amount: '€100-€140 (LKR 34,000-48,000)',
          note: 'Application at German Embassy in Sri Lanka'
        },
        {
          item: 'Flight to Germany',
          amount: '€600-€900 (LKR 205,000-308,000)',
          note: 'One-way ticket'
        },
        {
          item: 'Blocked account (living + insurance)',
          amount: '€13,080/year (LKR 4,470,000/year)',
          note: 'Mandatory to prove funds for 12 months'
        },
        {
          item: 'Accommodation and living',
          amount: '€700-€1,200/month (LKR 240,000-410,000)',
          note: 'Rent, utilities, food, transport'
        },
        {
          item: 'Consulting fee',
          amount: 'LKR 1,390,000',
          note: '50% upfront (LKR 695,000) + balance after approval'
        }
      ],
      languageRequirements: [
        'German-taught positions: German B1/B2 minimum',
        'English-speaking positions: IELTS 6.0-6.5',
        'Recognized qualification or degree in relevant field'
      ],
      eligibility: [
        'Bachelor degree or recognized vocational qualification',
        'Relevant work experience (2+ years typical)',
        'Proof of funds for initial living expenses in Germany'
      ],
      highlights: [
        'Live and work in Germany while searching for employment',
        'Smooth transition to residence permit once employed',
        'Direct pathway toward EU permanent residency',
        'Gain German language skills in a professional environment'
      ],
      paymentPlan: [
        'Initial payment: LKR 695,000',
        'Balance after approval: LKR 695,000'
      ],
      serviceFeeLKR: 1390000,
      serviceCurrency: 'LKR'
    }
  },
  GBR: {
    student_visa: {
      headline: 'Study in the UK (Bachelor & Master)',
      durations: [
        'Foundation: 6-12 months (pathway to Bachelor)',
        'Bachelor: 3 years (4 years with placement)',
        'Master: 1 year full-time'
      ],
      popularFields: [
        'Business & Management',
        'Information Technology & Data Science',
        'Engineering (Mechanical, Civil, Software)',
        'Medicine, Nursing & Healthcare',
        'Law, Social Sciences, Arts & Design'
      ],
      costBreakdown: [
        {
          item: 'Tuition fees',
          amount: '£10,000-£20,000/year (Bachelor), £11,000-£22,000 total (Master)',
          note: 'Foundation: £8,000-£15,000'
        },
        {
          item: 'Living expenses',
          amount: '£9,000-£12,000 outside London; £12,000-£15,000 in London',
          note: 'Covers accommodation and daily living'
        },
        {
          item: 'Visa fee',
          amount: '£450',
          note: 'Includes biometric and processing charges'
        },
        {
          item: 'NHS health surcharge',
          amount: '£470/year',
          note: 'Mandatory health insurance'
        },
        {
          item: 'Consulting fee',
          amount: 'LKR 400,000',
          note: '200,000 LKR upfront + 200,000 LKR after offer letter'
        }
      ],
      languageRequirements: [
        'Foundation: IELTS 5.5',
        'Bachelor: IELTS 5.5 overall',
        'Master: IELTS 6.0 overall (many accept MOI proof)'
      ],
      eligibility: [
        'Foundation: Completed O/L or A/L (low grades accepted)',
        'Bachelor: A/L with minimum 2-3 passes',
        'Master: Recognized bachelor degree with competitive GPA'
      ],
      highlights: [
        'Complete a UK master degree in just 12 months',
        'Eligible for 2-year Graduate Route (3 years for PhD)',
        'Rich internship and part-time work opportunities',
        'Global alumni network and multicultural experience'
      ],
      paymentPlan: [
        'Initial payment: LKR 200,000',
        'Balance after offer letter: LKR 200,000'
      ],
      serviceFeeLKR: 400000,
      serviceCurrency: 'LKR'
    },
    foundation_course: {
      headline: 'UK Foundation Programs',
      durations: ['6-12 months leading to direct bachelor entry'],
      popularFields: [
        'Business',
        'Engineering',
        'Health & Life Sciences',
        'IT and Creative Arts'
      ],
      costBreakdown: [
        {
          item: 'Tuition fees',
          amount: '£8,000-£15,000',
          note: 'Depends on college and progression route'
        },
        {
          item: 'Living expenses',
          amount: '£9,000-£15,000/year',
          note: 'Varies by city'
        },
        {
          item: 'Visa and NHS surcharge',
          amount: '£920 combined',
          note: 'Student visa + NHS health surcharge'
        }
      ],
      languageRequirements: ['IELTS 5.5 overall (individual bands may vary)'],
      eligibility: ['O/L or A/L completion (flexible grade requirements)'],
      highlights: [
        'Fast-track path for students who need academic bridging',
        'Guaranteed progression to partner universities upon completion',
        'Integrated academic skills and English preparation',
        'Suitable for students switching study streams'
      ],
      paymentPlan: [
        'Consulting fee included within UK study package (LKR 400,000 total)'
      ],
      serviceFeeLKR: 400000,
      serviceCurrency: 'LKR'
    }
  },
  CAN: {
    certificate: {
      headline: 'Canada Certificate Programs (1 Year)',
      durations: ['1-year programs focused on job-ready skills'],
      popularFields: [
        'Business Administration & Accounting',
        'Information Technology and Web Development',
        'Healthcare and Nursing Assistant',
        'Hospitality & Tourism Management',
        'Skilled Trades'
      ],
      costBreakdown: [
        {
          item: 'Tuition fees',
          amount: 'CAD 17,000-22,500/year',
          note: 'Varies by province and college'
        },
        {
          item: 'Living expenses',
          amount: 'CAD 20,000-22,500/year',
          note: 'Rent, food, transport, personal'
        },
        {
          item: 'Visa & study permit',
          amount: 'CAD 150-250',
          note: 'Includes biometrics fee'
        },
        {
          item: 'Flight to Canada',
          amount: 'CAD 1,200-1,800',
          note: 'One-way ticket'
        },
        {
          item: 'Consulting fee',
          amount: 'LKR 1,150,000',
          note: '575,000 LKR upfront + 575,000 LKR after offer letter'
        }
      ],
      languageRequirements: [
        'IELTS 6.0 overall (TOEFL, PTE, MOI accepted by many colleges)'
      ],
      eligibility: [
        'Completed A/L or O/L with additional qualifications',
        'Program-specific prerequisites may apply'
      ],
      highlights: [
        'Fast track to Canadian job market',
        'Eligible for post-graduate work permit depending on program length',
        'Pathway to permanent residency via Canadian work experience',
        '💰 Study Loan Assistance: Up to 75% tuition, repayable in 4–7 years at 11% APR'
      ],
      paymentPlan: [
        'Initial down payment: 25% on offer letter',
        'Remaining 75% financed after arrival (CAD 398-790 monthly over 4-7 years)'
      ],
      serviceFeeLKR: 1150000,
      serviceCurrency: 'LKR',
      studyLoanAssistance: {
        coverage: 'Up to 75% of tuition',
        repaymentPeriod: '4-7 years',
        interestRate: '11% APR',
        monthlyPayment: 'CAD 398-790'
      }
    },
    diploma: {
      headline: 'Canada Diploma Programs (2 Years)',
      durations: ['Diplomas typically 2 years; advanced diplomas may extend to 3 years'],
      popularFields: [
        'Information Technology (Networking, Cybersecurity)',
        'Business and Supply Chain',
        'Engineering Technician programs',
        'Healthcare support services',
        'Media, Design, Animation'
      ],
      costBreakdown: [
        {
          item: 'Tuition fees',
          amount: 'CAD 17,000-22,500/year',
          note: 'Second year similar to first year costs'
        },
        {
          item: 'Living expenses',
          amount: 'CAD 20,000-22,500/year',
          note: 'Budget includes GIC requirement (CAD 20,000 typical)'
        },
        {
          item: 'Visa, study permit & biometrics',
          amount: 'CAD 150-250',
          note: 'One-time'
        },
        {
          item: 'Consulting fee',
          amount: 'LKR 1,150,000',
          note: '575,000 LKR upfront + 575,000 LKR after offer letter'
        }
      ],
      languageRequirements: [
        'IELTS 6.0 overall (individual band minimums may apply)'
      ],
      eligibility: [
        'A/L completion with relevant subjects or experience',
        'Higher acceptance if foundation or diploma background exists'
      ],
      highlights: [
        'Full 3-year post-graduate work permit eligibility',
        'In-demand programs aligned with Canadian immigration streams',
        'Internships and co-op work terms embedded in many diplomas',
        '💰 Study Loan Assistance: Up to 75% tuition, repayable in 4–7 years at 11% APR'
      ],
      paymentPlan: [
        'Initial 25% down payment at offer letter stage',
        'Remaining tuition covered by loan with CAD 398-790 monthly repayment across 4-7 years'
      ],
      serviceFeeLKR: 1150000,
      serviceCurrency: 'LKR',
      studyLoanAssistance: {
        coverage: 'Up to 75% of tuition',
        repaymentPeriod: '4-7 years',
        interestRate: '11% APR',
        monthlyPayment: 'CAD 398-790'
      }
    }
  },
  AUS: {
    student_visa: {
      headline: 'Study in Australia (Bachelor & Master)',
      durations: [
        'Bachelor: 3 years (4 years with honors)',
        'Master: 1.5-2 years full-time'
      ],
      popularFields: [
        'Business & Management',
        'Information Technology & Computer Science',
        'Engineering (Civil, Mechanical, Software)',
        'Medicine, Nursing & Healthcare',
        'Law, Arts, Design & Social Sciences'
      ],
      costBreakdown: [
        {
          item: 'Tuition fees',
          amount: 'AUD 20,000-45,000/year',
          note: 'Varies by university and program'
        },
        {
          item: 'Living expenses',
          amount: 'AUD 21,041/year',
          note: 'Includes accommodation and daily living'
        },
        {
          item: 'Visa fee',
          amount: 'AUD 650',
          note: 'Student visa application fee'
        },
        {
          item: 'OSHC health insurance',
          amount: 'AUD 500-700/year',
          note: 'Mandatory health insurance'
        },
        {
          item: 'Consulting fee',
          amount: 'LKR 1,190,000',
          note: '476,000 LKR upfront + 357,000 after offer + 357,000 final'
        }
      ],
      languageRequirements: [
        'IELTS 6.5 overall (varies by program)',
        'TOEFL, PTE also accepted'
      ],
      eligibility: [
        'Bachelor: A/L with minimum 2-3 passes',
        'Master: Recognized bachelor degree with competitive GPA',
        'Show money: LKR 5M minimum'
      ],
      highlights: [
        'PR pathways available after graduation',
        'Post-study work options 2-4 years depending on degree',
        'Part-time work 40 hours per fortnight during studies',
        'High-quality education with global recognition'
      ],
      paymentPlan: [
        'Initial payment: LKR 476,000 (40%)',
        'After offer letter: LKR 357,000 (30%)',
        'Final payment: LKR 357,000 (30%)'
      ],
      serviceFeeLKR: 1190000,
      serviceCurrency: 'LKR'
    },
    masters: {
      headline: 'Australia Master Programs',
      durations: ['1.5-2 years full-time'],
      popularFields: [
        'Master of Business Administration (MBA)',
        'Master of Information Technology',
        'Master of Engineering',
        'Master of Nursing',
        'Master of Data Science'
      ],
      costBreakdown: [
        {
          item: 'Tuition fees',
          amount: 'AUD 25,000-50,000/year',
          note: 'Premium programs may cost more'
        },
        {
          item: 'Living expenses',
          amount: 'AUD 21,041/year',
          note: 'Varies by city and lifestyle'
        },
        {
          item: 'OSHC health insurance',
          amount: 'AUD 500-700/year',
          note: 'Mandatory for student visa'
        }
      ],
      languageRequirements: ['IELTS 6.5 overall (no band below 6.0)'],
      eligibility: [
        'Recognized bachelor degree',
        'Competitive GPA required',
        'Show money: LKR 5M minimum'
      ],
      highlights: [
        '2-4 years post-study work rights',
        'Pathway to permanent residency',
        'Work while studying opportunities',
        'Research opportunities available'
      ],
      paymentPlan: [
        'Initial payment: LKR 476,000 (40%)',
        'After offer letter: LKR 357,000 (30%)',
        'Final payment: LKR 357,000 (30%)'
      ],
      serviceFeeLKR: 1190000,
      serviceCurrency: 'LKR'
    }
  },
  NZL: {
    student_visa: {
      headline: 'Study in New Zealand (Bachelor & Master)',
      durations: [
        'Bachelor: 3 years',
        'Master: 1-2 years full-time'
      ],
      popularFields: [
        'Business & Management',
        'Information Technology',
        'Engineering',
        'Healthcare & Nursing',
        'Agriculture & Environmental Sciences'
      ],
      costBreakdown: [
        {
          item: 'Tuition fees',
          amount: 'Contact for specific pricing',
          note: 'Varies by university and program'
        },
        {
          item: 'Living expenses',
          amount: 'Contact for specific pricing',
          note: 'Varies by city and lifestyle'
        },
        {
          item: 'Visa fee',
          amount: 'Contact for current fees',
          note: 'Student visa application required'
        },
        {
          item: 'Consulting fee',
          amount: 'LKR 1,190,000',
          note: '476,000 LKR upfront + 357,000 after offer + 357,000 final'
        }
      ],
      languageRequirements: [
        'IELTS 6.0-6.5 (varies by program)',
        'TOEFL, PTE also accepted'
      ],
      eligibility: [
        'Bachelor: A/L with minimum passes',
        'Master: Recognized bachelor degree',
        'Show money: LKR 5M minimum'
      ],
      highlights: [
        'Study-to-residency migration support',
        'Post-study work and residency pathways',
        'Beautiful environment with excellent quality of life',
        'Work-life balance opportunities'
      ],
      paymentPlan: [
        'Initial payment: LKR 476,000 (40%)',
        'After offer letter: LKR 357,000 (30%)',
        'Final payment: LKR 357,000 (30%)'
      ],
      serviceFeeLKR: 1190000,
      serviceCurrency: 'LKR'
    },
    work_visa: {
      headline: 'New Zealand Work Visa & Migration',
      durations: ['1-3 years (renewable)'],
      popularFields: [
        'Skilled Migration',
        'Work to Residence pathways',
        'Essential skills work visa',
        'Post-study work visa'
      ],
      costBreakdown: [
        {
          item: 'Visa application fee',
          amount: 'Contact for current pricing',
          note: 'Varies by visa type'
        },
        {
          item: 'Medical & police checks',
          amount: 'Contact for specific costs',
          note: 'Required for most work visas'
        },
        {
          item: 'Consulting fee',
          amount: 'LKR 1,190,000',
          note: '476,000 LKR upfront + 357,000 after approval + 357,000 final'
        }
      ],
      languageRequirements: [
        'IELTS 6.0-6.5 (varies by visa category)',
        'English proficiency required'
      ],
      eligibility: [
        'Relevant qualifications or work experience',
        'Job offer from NZ employer (for some categories)',
        'Meet health and character requirements'
      ],
      highlights: [
        'Work Visa and study-to-residency migration support',
        'Post-study work and residency pathways available',
        'High success rates for qualified applicants',
        'Support through entire migration journey'
      ],
      paymentPlan: [
        'Initial payment: LKR 476,000 (40%)',
        'After approval: LKR 357,000 (30%)',
        'Final payment: LKR 357,000 (30%)'
      ],
      serviceFeeLKR: 1190000,
      serviceCurrency: 'LKR'
    }
  }
};

export const getRavanaProfile = (countryCode, pathwayKey) => {
  if (!countryCode || !pathwayKey) return null;
  const countryProfiles = ravanaPathwayProfiles[countryCode.toUpperCase()];
  if (!countryProfiles) return null;
  // Normalize pathway key: certificate/diploma may be named differently in DB
  const normalizedKey = pathwayKey.toLowerCase();
  if (countryProfiles[normalizedKey]) {
    return countryProfiles[normalizedKey];
  }

  // Handle alternate keys
  if (normalizedKey === 'student_visa' && countryProfiles.student_visa) {
    return countryProfiles.student_visa;
  }
  if (normalizedKey === '1_year_pg_certificate' && countryProfiles.certificate) {
    return countryProfiles.certificate;
  }
  if (normalizedKey === '2_year_pg_diploma' && countryProfiles.diploma) {
    return countryProfiles.diploma;
  }
  if (normalizedKey === 'bachelor' && countryProfiles.student_visa) {
    return countryProfiles.student_visa;
  }
  if (normalizedKey === 'masters' && countryProfiles.masters) {
    return countryProfiles.masters;
  }
  if (normalizedKey === 'master' && countryProfiles.masters) {
    return countryProfiles.masters;
  }

  return null;
};

export default ravanaPathwayProfiles;
